import { useEffect } from 'react';

/**
 * Hook to manage popover focus behavior:
 * - Closes on Escape key
 * - Closes when focus leaves (but not during mouse/keyboard interactions)
 */
export function usePopoverFocus(containerRef, onClose, isOpen) {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let isInteracting = false;

    const setInteracting = () => {
      isInteracting = true;
      setTimeout(() => (isInteracting = false), 100);
    };

    const handleKeyDown = e => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose?.();
      } else if (e.key === 'Enter' || e.key === ' ') {
        setInteracting();
      }
    };

    const handleFocusOut = () => {
      setTimeout(() => {
        if (!isInteracting && !container.contains(document.activeElement)) {
          onClose?.();
        }
      }, 0);
    };

    container.addEventListener('keydown', handleKeyDown);
    container.addEventListener('mousedown', setInteracting);
    container.addEventListener('focusout', handleFocusOut);

    return () => {
      container.removeEventListener('keydown', handleKeyDown);
      container.removeEventListener('mousedown', setInteracting);
      container.removeEventListener('focusout', handleFocusOut);
    };
  }, [containerRef, onClose, isOpen]);
}
